import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useStore } from "../Store";

const SignalrClientComponent = () => {
  const { casesStore, signalrClient } = useStore();
  const ready = casesStore.isCaseLoaded;
  const version = casesStore.sessionVersion;

  useEffect(() => {
    if (!ready) {
      void signalrClient.closeConnection();
      return;
    }
    void signalrClient.openConnection();
    return () => { void signalrClient.closeConnection(); };
  }, [ready, version, signalrClient]);

  return null;
};

export default observer(SignalrClientComponent);
